<template>
    <q-page-container class="bg-white">
      <q-page>
        <main id="main-content" tabindex="-1">
          <router-view />
        </main>
        <FooterComponent />
      </q-page>
    </q-page-container>
</template>

<script>
import { useRoute } from "vue-router";
import { useMeta } from "quasar";
import FooterComponent from "components/Footer.vue";
import { marketingMetaFor } from "../router/marketingMeta";

export default {
  name: "Default",
  components: {FooterComponent},
  setup() {
    const route = useRoute();
    // The one place the title and description of every marketing page are set,
    // from the route's meta. useMeta renders into the HTML under SSR, and a
    // getter re-applies it when navigating between pages that share this
    // layout (two program pages, say). The views do not call useMeta
    // themselves: two sources would put two titles in the page.
    useMeta(() => marketingMetaFor(route));
  }
}
</script>

<style scoped>

</style>
